import { Navigate, Outlet } from "react-router-dom";
import { useSuperAdmin } from "@/hooks/useSuperAdmin";
import { APP_HOME_PATH } from "@/lib/copilot-home";

export function SuperAdminGuard() {
  const { isSuperAdmin, loading } = useSuperAdmin();

  // Render nothing while checking — a visible "Verificando acceso..." flash reads
  // as a glitch given the fade-in transition between routes.
  if (loading) return null;

  if (!isSuperAdmin) {
    return <Navigate to={APP_HOME_PATH} replace />;
  }

  return <Outlet />;
}
